export default {
  more: '查看更多',
  retract: '收起',
}
